import React, { useRef, useState } from "react";
import backgroundImage from "../img/A.jpeg";

const Home = () => {
  const scrollContainerRef = useRef(null);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const scrollToSection = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="home" ref={scrollContainerRef} className="w-full min-w-full h-full flex-shrink-0 snap-start relative flex flex-col" style={{ backgroundImage: `url(${backgroundImage})`, backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "cover" }}>
      <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center px-4 py-6 sm:py-8">
        <div className="text-center text-white max-w-4xl">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6 leading-tight">
            Driscoll Company Real Estate
          </h1>
          <p className="text-base sm:text-lg md:text-xl mb-8 sm:mb-10 text-gray-100 max-w-3xl mx-auto px-1">
            Serving St. Louis since 2004 with a client-first approach to real estate sales & leasing.
          </p>
          <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-3 sm:gap-4">
            <button onClick={() => scrollToSection("commercial")} className="w-full sm:w-auto px-6 sm:px-8 py-3.5 sm:py-4 text-base sm:text-lg font-semibold bg-white text-gray-900 rounded-lg hover:bg-gray-100 active:bg-gray-200 transition shadow-lg touch-manipulation min-h-[48px]">
              Commercial
            </button>
            <button onClick={() => scrollToSection("residential")} className="w-full sm:w-auto px-6 sm:px-8 py-3.5 sm:py-4 text-base sm:text-lg font-semibold border-2 border-white text-white rounded-lg hover:bg-white hover:text-gray-900 active:bg-gray-200 transition touch-manipulation min-h-[48px]">
              Residential
            </button>
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 w-full bg-white/90 backdrop-blur py-3 px-4 pb-[env(safe-area-inset-bottom)] flex flex-col sm:flex-row justify-center items-center gap-3 sm:gap-4">
        <button onClick={() => scrollToSection("contact")} className="text-sm font-medium text-gray-600 hover:text-gray-900 transition py-2 min-h-[44px] flex items-center touch-manipulation">Contact</button>
        <div className="relative">
          <button onClick={() => setDropdownOpen(!isDropdownOpen)} className="text-sm font-medium text-gray-600 hover:text-gray-900 transition flex items-center py-2 min-h-[44px] touch-manipulation">Application <span className="ml-1 text-xs">▼</span></button>
          {isDropdownOpen && (
            <div className="absolute left-1/2 -translate-x-1/2 mt-2 w-44 bg-white shadow-lg rounded-md py-1 z-50 border border-gray-100">
              <button onClick={() => { setModalOpen(true); setDropdownOpen(false); }} className="block w-full text-left px-4 py-3 text-sm hover:bg-gray-100 min-h-[44px] flex items-center touch-manipulation">View Application</button>
              <a href="/documents/Rental_Application.pdf" download className="block w-full text-left px-4 py-3 text-sm hover:bg-gray-100 min-h-[44px] flex items-center touch-manipulation">Download PDF</a>
            </div>
          )}
        </div>
      </div>
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
          <div className="bg-white p-4 sm:p-6 rounded-lg shadow-xl w-full max-w-lg max-h-[90vh] flex flex-col">
            <h2 className="text-xl sm:text-2xl font-bold mb-4 text-gray-900">Rental Application</h2>
            <div className="flex-1 min-h-0 overflow-hidden rounded-lg border">
              <iframe src="/documents/Rental_Application.pdf" className="w-full h-[60vh] sm:h-[500px] border-0" title="Rental Application" />
            </div>
            <div className="flex justify-end mt-4"><button onClick={() => setModalOpen(false)} className="bg-red-600 text-white px-4 py-3 rounded-md text-sm font-semibold hover:bg-red-700 min-h-[44px] touch-manipulation">Close</button></div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Home;
